const accordions = document.querySelectorAll(".jsAccordionItem");

const openAccordion = (accordion) => {
	const content = accordion.querySelector(".jsAccordionContent");
	accordion.classList.add("accordion--active");
	content.style.maxHeight = content.scrollHeight + "px";
};

const closeAccordion = (accordion) => {
	const content = accordion.querySelector(".jsAccordionContent");
	accordion.classList.remove("accordion--active");
	content.style.maxHeight = null;
};

accordions.forEach((accordion) => {
	const intro = <HTMLElement>accordion.querySelector(".jsAccordionTitle");
	const content = <HTMLElement>accordion.querySelector(".jsAccordionContent");

	intro!.onclick = () => {
		if (content!.style.maxHeight) {
			closeAccordion(accordion);
		} else {
			accordions.forEach((accordion) => closeAccordion(accordion));
			openAccordion(accordion);
		}
	};
});